import { useEffect, useState } from 'react';

const usePumpData = (APP_SERVICES_URL, CustID, site, authHeader) => {
  const [totalPump, setTotalPump] = useState(0);
  const [pumpDetails, setPumpDetails] = useState([]);
  const [error, setError] = useState(null); // New error state
  const [loading, setLoading] = useState(true); // New loading state

  useEffect(() => {
    const fetchPumpData = async () => {
      setLoading(true); // Set loading state to true
      try {
        const response = await fetch(
          `${APP_SERVICES_URL}/senapi/${CustID}/pumps?siteName=${site}`,
          {
            method: "GET",
            headers: {
              Authorization: authHeader,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch pump data");
        }

        const pumpData = await response.json();

        // Update cameraData with the fetched data
        const filteredPump = pumpData.filter(item => item.status !== 'DELETED')
        setTotalPump((filteredPump?.length || 0));
        setPumpDetails(filteredPump);
      } catch (error) {
        setError(error.message); // Update error state
        console.error("Error fetching pump data:", error);
      } finally {
        setLoading(false); // Set loading to false regardless of success or error
      }
    };

    fetchPumpData();
  }, [APP_SERVICES_URL, CustID, site, authHeader]);

  return { totalPump, pumpDetails, error, loading }; // Return error and loading states
};

export default usePumpData;
